import { Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { AgRendererComponent } from 'ag-grid-angular';
import { Router } from '@angular/router';
import { EntityServiceProvider } from '@shared/services';
import { get, includes, isEmpty, isEqual } from 'lodash';
import { ENTITY_TYPES, IBaseEntityType } from '@app/shared/types';
import { STATUS_VALUE } from '@shared/types/enums/status.enum';
import { GROUP_AUTO_RESTOCK_ROUTE } from '@app/shared/services/transfer-group-auto-restock/transfer-group-auto-restock.constants';
import { isGroupAutoRestockPage } from '@app/shared/utils/transfer-group.auto-restock.utils';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: 'xvi-link-renderer',
  templateUrl: './link-renderer.component.html',
  styleUrls: ['./link-renderer.component.scss'],
})
export class XVILinkRendererComponent implements AgRendererComponent {
  public data: IBaseEntityType;
  public text: string;
  public entityType: string;
  public needGetUpdateItemsStatus: string[];
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public onClick = (data: any, params?: ICellRendererParams): void => {};
  public params: ICellRendererParams = null;
  public constructor(
    private router: Router,
    private entityServiceProvider: EntityServiceProvider,
  ) {}

  public agInit(params: ICellRendererParams): void {
    const cellRendererParams = get(params, 'colDef.cellRendererParams', {});
    this.text = params.value;
    this.data = params.node.data;
    this.params = params;
    this.entityType = get(cellRendererParams, 'entityType', null);
    this.needGetUpdateItemsStatus = get(
      cellRendererParams,
      'needGetUpdateItemsStatus',
      [STATUS_VALUE.Open],
    );
    this.onClick = get(cellRendererParams, 'onClick', this.onClick);
  }

  public refresh(): boolean {
    return true;
  }

  public handleLinkClick(): void {
    this.onClick(this.data, this.params);
    if (isEmpty(this.entityType)) return;
    const status = get(this, 'data.status');
    const service = this.entityServiceProvider.getService(this.entityType);

    const defaultParams = {
      ...(service.config?.editor?.enableEntryDuplicate && {
        showDuplicate: true,
      }),
    };

    // #TODO is code here right?
    if (isEqual(this.entityType, ENTITY_TYPES.TRANSFER_GROUP)) {
      if (isGroupAutoRestockPage(this.data)) {
        this.router.navigate(
          [GROUP_AUTO_RESTOCK_ROUTE, get(this, 'data._id', '')],
          {
            ...defaultParams,
            queryParams: {
              get_updated_items: includes(this.needGetUpdateItemsStatus, status)
                ? true
                : null,
            },
          },
        );

        return;
      }
    }
    this.router.navigate([service.config.uiRoute, get(this, 'data._id', '')], {
      queryParams: {
        ...defaultParams,
        get_updated_items: includes(this.needGetUpdateItemsStatus, status)
          ? true
          : null,
      },
    });
  }
}
